<template>
  <transition name="fade">
    <div v-if="notice" :class="['notification', notice.status]">
      <span v-text="notice.message"/>
    </div>
  </transition>
</template>


<script>
export default {
  name: 'CommonNotification',

  data: () => ({
    timeout: null,
    notice: null,
  }),

  created() {
    this.$bus.$on('showNotification', notice => {
      clearTimeout(this.timeout);
      this.notice = notice;
      this.timeout = setTimeout(() => {
        this.notice = null;
      }, 5500);
    });
  },
};
</script>


<style lang="scss" scoped>
.notification {
  z-index: 1000;
  animation: notification 3s ease;
  animation-fill-mode: forwards;
  position: absolute;
  top: -15%;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  font-family: Arial, Helvetica, sans-serif;
  background-color: #d4edda;
  text-align: center;
  padding: 20px 12px;
  border-radius: 8px;

  &.success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }

  &.danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }

  &.warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }

  &.danger-game {
    color: #fff;
    background-color: #ff2135;
    border: none;
  }

  &.warning-game {
    color: #fff;
    background-color: #e4c769;
    border: none;
  }

  &.success-game {
    color: #fff;
    background-color: #3cc45b;
    border: none;
  }
}
	
@keyframes notification { 
  0% {
    top: -3%;
  }
  100% {
    top: 5%;
  }
}
</style>